var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"min-h-70px border-dashed border-2 border-primary w-full rounded\noutline-none",attrs:{"type":"text"}},[_c('span',{staticClass:"text-primary font-bold text-sm"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }